export default "__VITE_ASSET__97fb7275__"